<div class="card">
    <div class="card-header">
       IMEI Search
    </div>
    <div class="card-body">
        <div class="row m-1">
            <div class="col-md-1 px-1">
                <label class="Label">IMEI No:</label>
            </div>
            <div class="col-md-4 px-1">
                <input name="imeino" [(ngModel)]="IMEINo" type="text" class="form-control"
                    (keypress)="onKeyPress()"  placeholder="Enter IMEI No." />
            </div>
            <div class="col-md-2 px-1">
                
                <button class="btn btn-sm btn-primary" name="submit" (click)="Search()">
                    <i class="bi bi-search" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Search':'Loading...'}}
                </button>
            </div>
        </div>
        <hr>    
        <div>
            <div class="card border-radius-0 mt-1 p-0">
                <div class="card-header">
                    Data
                </div>
                <div class="card-body p-1" style="overflow: auto;">
                    <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger"
                        class="customeDatatable table table-bordered">
                        <thead class="table-light">
                            <tr>
                                <th scope="col" style="width: 2px;" >#</th>
                                <th scope="col">Branch Name</th>
                                <th scope="col">Customer Group</th>
                                <th scope="col">Site Name</th>
                                <th scope="col" style="display: none;">Employee Master ID</th>
                                <th scope="col">Employee Code</th>
                                <th scope="col">Employee Type</th>
                                <th scope="col">Employee Name</th>
                                <th scope="col">IMEI No.</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let site of IMEINoLoad; let i = index">
                                <th scope="row">{{ i + 1 }}</th>
                                <td>{{ site['BranchName'] }}</td>
                                <td>{{ site['CustomerGroup'] }}</td>
                                <td>{{ site['SiteName'] }}</td>
                                <td style="display: none;">{{ site['EmpMasterID'] }}</td>
                                <td>{{ site['EmpCode'] }}</td>
                                <td>{{ site['EmpType'] }}</td>
                                <td>{{ site['FullName'] }}</td>
                                <td>{{ site['IMEINumber'] }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>